import React, { useEffect, useRef } from "react";
import { SearchIcon } from "../assets/icons/Icons";

type SearchBarProps = {
  className?: string;
  inputCss?: string;
  placeholder?: string;
  autoFocus?: boolean;
};

export default function SearchBar({ className, placeholder, inputCss, autoFocus }: SearchBarProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleStart = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);

  return (
    <div
      onClick={handleStart}
      className={`p-2 px-3 rounded-full flex items-center gap-2 ${className}`}
    >
      <SearchIcon />
      <input
        ref={inputRef}
        className={`font-medium text-black flex-grow outline-none ${inputCss}`}
        placeholder={placeholder || "Search profiles & groups"}
      />
    </div>
  );
}